import { useEffect, useState } from "react";
import HeaderComponent from "./Header/HeaderComponent";
import MenuComponent from "./Menu/MenuComponent";
import MobileHeaderComponent from "./Header/MobileHeaderComponent";
import { useTranslation } from "react-i18next";
import "bootstrap-icons/font/bootstrap-icons.css";
import { any, target } from "glamor";
import { getDivisionsItems, getGovernanceDocumentsItems } from "../../api/api";
import { useQuery } from "react-query";

const LayoutTop = () => {
  const { i18n, t } = useTranslation();

  type Language = "en" | "ar";

  const sectorIds: Record<Language, Record<string, string>> = {
    ar: {
      internal_review: "/Divisions/1",
      strategy_and_institutional_transformation: "/Divisions/2",
      human_capital: "/Divisions/3",
      finance: "/Divisions/4",
      business_development: "/Divisions/5",
      shared_services: "/Divisions/6",
      corporate_communication: "/Divisions/7",
    },
    en: {
      internal_review: "/Divisions/1",
      strategy_and_institutional_transformation: "/Divisions/2",
      human_capital: "/Divisions/3",
      finance: "/Divisions/4",
      business_development: "/Divisions/5",
      shared_services: "/Divisions/6",
      corporate_communication: "/Divisions/7",
    },
  };
 
  const currentSectorIds = sectorIds[i18n.language as Language] || sectorIds.ar;

  const { isLoading, error, data, refetch }: any = useQuery(
    "HomeDivistionsData",
    () => getDivisionsItems({ limit: 5, language: i18n.language })
  );

  const GovernanceDocumentsItems = useQuery("getGovernanceDocumentsItems", 
  () => getGovernanceDocumentsItems({ language: i18n.language })
  );

  const [dataGovernance, setDataGovernance] = useState([]);
  const [menu, setMenu] = useState([
    {
      link: "/",
      title_key: "home",
    },
    {
      link: "#",
      // title_key: "eportal",
      title_key: t(`eportal`),

      items1: [
        {
          link: "http://eportal.rafedsa.com",
          //title_key: "tatweer_educational_transportation_services_company",
          title_key: t(
            `menu.tatweer_educational_transportation_services_company`
          ),
          target: "_blank",
        },
        {
          link: "https://hrsurvey.talemia.sa/socialscreen/home/portal",
          //title_key: "tatweer_company_for_educational_services",
          title_key: t(`menu.tatweer_company_for_educational_services`),
        },
        {
          link: "https://Portal.tbc.sa",
          // title_key: "tatweer_building_company",
          title_key: t(`menu.tatweer_building_company`),
        },
        {
          link: "https://portal.tetco.sa",
          //title_key: "tatweer_educational_technologies_company",
          title_key: t(`menu.tatweer_educational_technologies_company`),
        },
      ],
    },
    //governance_documents
    {
      link: "#",
      title_key: `governance_documents`,

      // items1: [
      //   {
      //     link: "/GovernanceDocuments/InstitutionalPolicies",
      //     title_key: t(`institutional_policies`),
      //   },
      //   {
      //     link: "/GovernanceDocuments/OperationalPolicies",
      //     title_key: t(`operational_policies`),
      //   },
      //   {
      //     link: "/GovernanceDocuments/AuthorityMatrix",
      //     title_key: t(`authority_matrix`),
      //   },
      //   {
      //     link: "/GovernanceDocuments/OrganizationalStructure",
      //     title_key: t(`organizational_structure`),
      //   },
      // ],
    },
    {
      link: "#",
      title_key: `sectors`,

      items1: [
        // { link: "/Divisions/23", title_key: "ceo" },
        // {
        //   link: currentSectorIds.internal_review,
        //   title_key: "internal_review",
        // },
        // {
        //   link: currentSectorIds.strategy_and_institutional_transformation,
        //   title_key: "strategy_and_institutional_transformation",
        // },
        // { link: currentSectorIds.human_capital, title_key: "human_capital" },
        // { link: currentSectorIds.finance, title_key: "finance" },
      ],
      items2: [
        // {
        //   link: currentSectorIds.business_development,
        //   title_key: "business_development",
        // },
        // {
        //   link: currentSectorIds.shared_services,
        //   title_key: "shared_services",
        // },
        // {
        //   link: currentSectorIds.corporate_communication,
        //   title_key: "corporate_communication",
        // },
        // { link: "/Divisions/19", title_key: "legal" },
        // { link: "/Divisions/21", title_key: "gov" },
      ],
    },

    {
      link: "#",
      title_key: t(`media_center`),
      items1: [
        { link: "/news", title_key: t(`menu.news`) },
        { link: "/gallery", title_key: t(`menu.gallery`) },
        { link: "/Announcement", title_key: t(`menu.announcements`) },
        { link: "/Magazines", title_key: t(`menu.magazines`) },
        { link: "/Offers", title_key: t(`menu.offers`) },
      ],
    },
    {
      link: "#",
      title_key: `faq`,
      items1: [
        //  { link: "/Structure", title_key: "organizational_structure" },
        {
          link: "/faq-list/3/annual_leaves",
          title_key: t(`menu.annual_leaves`),
        },
        {
          link: "/faq-list/4/medical_insurance",
          title_key: t(`menu.medical_insurance`),
        },
        {
          link: "/faq-list/5/card_request_mechanism",
          title_key: t(`menu.card_request_mechanism`),
        },
      ],
    },
    // {
    //   link: "#",
    //   title_key: `ads`,
    //   isIcon: true,
    //   items1: [
    //     //   { link: "/Vacancies", title_key: "recruitment" },
    //     { link: "/Activities", title_key: t(`menu.activities`) },
    //     { link: "/Initiatives", title_key: t(`menu.initiatives`) },
    //   ],
    // },
    {
      link: "/Vacancies",
      title_key: `recruitment`,
    },
  ]);
  useEffect(() => {
    setDataGovernance(GovernanceDocumentsItems?.data?.data);
    // console.log(dataGovernance.data);
  }, [GovernanceDocumentsItems]);

  // Update `menu` when either `data` or `dataGovernance` changes
  useEffect(() => {
  
    setMenu((prevMenu) => {
      const updatedMenu = [...prevMenu];
      if (data) {
        const transformedItems = data?.data.map((item: any) => ({
          link: `/Divisions/${item.id}`,
          title_key: item.attributes.title, // Adjust as per your data structure
        }));

        // Calculate the midpoint to split the array into two halves
        const midpoint = Math.ceil(transformedItems.length / 2);

        // Split transformedItems into two halves
        const items1Div = transformedItems.slice(0, midpoint); // First half
        const items2Div = transformedItems.slice(midpoint); // Second half

        //Update the menu state
        setMenu((prevMenu) => {
          const updatedMenu = [...prevMenu];
          updatedMenu[3].items1 = items1Div;
          updatedMenu[3].items2 = items2Div;
          return updatedMenu;
        });
      }

      if (dataGovernance) {
        const transformedItems = dataGovernance.map((item: any) => ({
          link: `/GovernanceDocuments/${item.id}`,
          title_key: item.attributes.title, // Adjust as per your data structure
        }));
        //Update the menu state
        setMenu((prevMenu) => {
          const updatedMenu = [...prevMenu];
          updatedMenu[2].items1 = transformedItems;
          return updatedMenu;
        });
      }
      return updatedMenu;
    });
  }, [data, dataGovernance]);

  // useEffect(() => {
  //   try {
  //     // Map the API data to the desired structure
  //     if (data) {
  //       const transformedItems = data?.data.map((item: any) => ({
  //         link: `/Divisions/${item.id}`,
  //         title_key: item.attributes.title, // Adjust as per your data structure
  //       }));

  //       // Calculate the midpoint to split the array into two halves
  //       const midpoint = Math.ceil(transformedItems.length / 2);

  //       // Split transformedItems into two halves
  //       const items1Div = transformedItems.slice(0, midpoint); // First half
  //       const items2Div = transformedItems.slice(midpoint); // Second half

  //       //Update the menu state
  //       setMenu((prevMenu) => {
  //         const updatedMenu = [...prevMenu];
  //         updatedMenu[3].items1 = items1Div;
  //         updatedMenu[3].items2 = items2Div;
  //         return updatedMenu;
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // }, [data]);

  // useEffect(() => {
  //   console.log("getGovernanceDocumentsItems ", dataGovernance, menu);
  //   try {
  //     // Map the API data to the desired structure
  //     if (dataGovernance) {
  //       const transformedItems = dataGovernance?.data.map((item: any) => ({
  //         link: `/GovernanceDocuments/${item.id}`,
  //         title_key: item.attributes.title, // Adjust as per your data structure
  //       }));
  //       //Update the menu state
  //       setMenu((prevMenu) => {
  //         const updatedMenu = [...prevMenu];
  //         updatedMenu[2].items1 = transformedItems;
  //         return updatedMenu;
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // }, [dataGovernance]);

  return (
    <>
      <HeaderComponent />
      <MobileHeaderComponent items={menu} />
      <MenuComponent items={menu} />
    </>
  );
};

export default LayoutTop;
